import React, { useRef, useState, useEffect, useContext } from "react";
import { ThemeContext } from 'styled-components';
import * as S from "./FlorenzBreadCrumb.style.js";
import { ZaiaImage } from "../../zaiaComponents/zaiaImage/ZaiaImage.style.js";

const defaultDoctor = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaImgDefault/default-doctor.png`;

function florenzBreadCrumb({ 
  steps,
  stepSelected,
  setStep,
  form
}) {

  
  return (
    <S.florenzBreadCrumb>
      {
        steps.map((step) => {
          
          const disabled = step.dependent 
          ? step.dependent.filter((dependent) => form[dependent].value === null || form[dependent].value === false || form[dependent].value?.length === 0).length > 0 
          : null;
    
          return (

            <div className={
              `step 
                ${step.disabled || disabled? ' step__disabled' : ''}
                ${step.id === stepSelected ? ' step__selected' : ''}
              `
            }
              key={step.id}
              onClick={() => 
                (!step?.disabled && !disabled) &&
                setStep(step.id)}
            >
              <div className="step__title">
                {step.title}
              </div>
              <div className="step__svg">
                <svg width="206" height="34" viewBox="0 0 206 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.15905 4.67875C-0.18623 2.6863 1.2413 0 3.64538 0H186.293C187.04 0 187.759 0.278229 188.311 0.780346L204.446 15.4501C205.795 16.6768 205.747 18.8133 204.344 19.978L188.286 33.3082C187.748 33.7553 187.07 34 186.37 34H3.94966C1.48685 34 0.0732188 31.1964 1.53756 29.2163L8.73915 19.4777C9.49485 18.4558 9.52459 17.0686 8.81337 16.0153L1.15905 4.67875Z" 
                    fill={
                      (step?.disabled || disabled)
                      ? "#CFD3DD"
                      : "#F0F0FF"
                    }
                  />
                </svg>
              </div>
            </div>
          )        
        })
      } 
    </S.florenzBreadCrumb>
  );
}

export default florenzBreadCrumb;
